module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/role-group-selection-box/role-group-selection-box.component.scss
// module id = ./src/app/modules/boxoffice-module/common/role-group-selection-box/role-group-selection-box.component.scss
// module chunks = 9